import { DAILY_BRIEF_NUDGE_ID } from '../../../constants';

/**
 * Opt-in set of nudge IDs that participate in suppression.
 *
 * Only nudges listed here are suppressed after being shown — all others keep their existing behavior.
 * Nudges are onboarded incrementally. See the tech spec for the suitability checklist and onboarding steps.
 */

export const SUPPRESSION_ALLOWLIST: ReadonlySet<string> = new Set([
	DAILY_BRIEF_NUDGE_ID,
]);

/**
 * Returns the suppression key for a nudge, or `null` if the nudge is not allowlisted.
 * Key format: `<id>` or `<id>:<suppressionKey>` when the consumer provides a `suppressionKey`.
 */
export const getSuppressionKey = (
	id: string,
	suppressionKey?: string,
	allowlist: ReadonlySet<string> = SUPPRESSION_ALLOWLIST,
): string | null => {
	if (!allowlist.has(id)) {
		return null;
	}
	return suppressionKey ? `${id}:${suppressionKey}` : id;
};
